import { Dispatch, SetStateAction, useState } from 'react'
import { query } from '@cbgms/components/list'

export interface logType {
  CustomerLog: {
    CustomerLogUUID: string
    CustomerEosId: string
    AppId: number
    Src: string
    LogLevel: string
    LogMessage: string
    CreatedByName: string
    CreatedAt: string
  }
}

export interface LogQueryTypes {
  error: boolean
  warn: boolean
  info: boolean
  customerEosId: string
  appId: number
}
export interface UseSearchByQuery {
  apiSearchQuery: string
  setQueryType: Dispatch<SetStateAction<LogQueryTypes>>
}
export const useLogsQueryByType = (): UseSearchByQuery => {
  const [queryType, setQueryType] = useState<LogQueryTypes>({ error: false, warn: false, info: false, customerEosId: '', appId: 1 })

  function getApiSearchQuery(queryType: LogQueryTypes) {
    let queryString = query<logType>().equals(o => o.CustomerLog.CustomerEosId, queryType.customerEosId)
    const { error, warn, info } = queryType
    switch (true) {
      case !warn && !error && !info:
        queryString = query<logType>().equals(o => o.CustomerLog.CustomerEosId, 'xxxxxxxxxxxxxx')
        break
      case warn && error && info:
        queryString = query<logType>().equals(o => o.CustomerLog.CustomerEosId, queryType.customerEosId)
        break
      case warn && error:
        queryString = query<logType>()
          .notEquals(o => o.CustomerLog.LogLevel, 'INFO')
          .and()
          .equals(o => o.CustomerLog.CustomerEosId, queryType.customerEosId)
        break
      case warn && info:
        queryString = query<logType>()
          .notEquals(o => o.CustomerLog.LogLevel, 'ERROR')
          .and()
          .equals(o => o.CustomerLog.CustomerEosId, queryType.customerEosId)
        break
      case error && info:
        queryString = query<logType>()
          .notEquals(o => o.CustomerLog.LogLevel, 'WARN')
          .and()
          .equals(o => o.CustomerLog.CustomerEosId, queryType.customerEosId)
        break
      case error:
        queryString = query<logType>()
          .equals(o => o.CustomerLog.LogLevel, 'ERROR')
          .and()
          .equals(o => o.CustomerLog.CustomerEosId, queryType.customerEosId)
        break
      case info:
        queryString = query<logType>()
          .equals(o => o.CustomerLog.LogLevel, 'INFO')
          .and()
          .equals(o => o.CustomerLog.CustomerEosId, queryType.customerEosId)
        break
      case warn:
        queryString = query<logType>()
          .equals(o => o.CustomerLog.LogLevel, 'WARN')
          .and()
          .equals(o => o.CustomerLog.CustomerEosId, queryType.customerEosId)
        break
      default:
        queryString = query<logType>().equals(o => o.CustomerLog.CustomerEosId, queryType.customerEosId)
        break
    }

    return queryString.toString()
  }

  const apiSearchQuery = getApiSearchQuery(queryType)

  return { setQueryType, apiSearchQuery }
}
